import React, { Component } from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import '../helpers/footer/footer.css';
import './agenda-style.css';
import './bootstrap.css';
import lobbyImg from '../images/medexIcon/RECEPTION-LOBBY-MED.png';
import feedbackImg from '../images/medexIcon/feedback.png';
import webinarImg from '../images/medexIcon/WEBINAR-MED.png';
import ArchiveImg from '../images/medexIcon/archive.png';
import displaygallaryImg from '../images/medexIcon/country-room.png';
import entertainmentImg from '../images/medexIcon/entertain-med.png';
import agendaImg from '../images/medexIcon/agenda.png';
import displayGallery from '../images/medexIcon/Display Gallery.png'
import facultyIcon from '../images/medexIcon/merz-faculty.png'
import logout from '../images/medexIcon/logout.png';
import tutorialimg1 from '../images/desktopangels1.jpg';
import tutorialimg2 from '../images/mobangels2.jpg';
import playImg from '../images/medexIcon/play-med.png';
import pauseImg from '../images/medexIcon/pause-med.png';
import closeBtn from '../images/medexIcon/cross.png'
// import videoPosterImg from '../images/emma-video-poster.png';
import menuImg from '../images/menu.png';
import closeImg from '../images/cross.png';

import sabestianImg from '../images/agenda/Sebastian.png';
import mattImg from '../images/agenda/Matt.png';
import mohamedImg from '../images/agenda/Mohamed.png';
import nabilImg from '../images/agenda/Nabil.png';
import naifImg from '../images/agenda/Naif.png';
import ramiImg from '../images/agenda/Rami.png';
import tatjanaImg from '../images/agenda/Tatjana.png';

import loginFirebaseApp from '../functions/features/login-firebase-app';
import authFirebaseApp from '../functions/features/auth-firebase-app';

import dbFirebaseApp from '../functions/features/db-firebase-app';
import emma from '../images/medexIcon/emma.png'
import { updateLastSceneEndTime } from '../functions/helpers/analytics-function';
import analyticsFirebase from '../functions/features/analytics-firebase-app';
import CustomNotification from '../helpers/notification/notification';

const entranceVideo = 'https://pptvr-videos.s3.ap-south-1.amazonaws.com/video/public/video2d/angels/Merz-Emma-Video-final.mp4'
const videoPosterImg = 'https://pptvr-images.s3.ap-south-1.amazonaws.com/image/public/image2d/angels-events/merz-emma-video-poster.png'
const expoName = 'merz'

export default class Footer extends Component {

    state = {
        isBtnLive: false,
        isVideoStart: false
    }

    componentDidMount() {
        this.getUserDetails()
        // var initialScreenSize = window.innerHeight;
        // window.addEventListener("resize", function () {
        //     if (window.innerHeight < initialScreenSize) {
        //         if (document.getElementById("bottommenu")) {
        //             document.getElementById("bottommenu").style.display = "none";
        //         }
        //         if (document.getElementById("quickAccessBtn")) {
        //             document.getElementById("quickAccessBtn").classList.add("btn-hover-shinebottom");
        //         }
        //         if (document.getElementById("Chat")) {
        //             document.getElementById("Chat").classList.add("chaticonpositionbottom");
        //         }
        //         if (document.getElementById("moderator1")) {
        //             document.getElementById("moderator1").classList.add("bottomtotopchat1");
        //         }
        //         if (document.getElementById("message-form")) {
        //             document.getElementById("message-form").classList.add("bottomtotopchat1");
        //         }

        //     } else {
        //         if (document.getElementById("bottommenu")) {
        //             document.getElementById("bottommenu").style.display = "block";
        //         }
        //         if (document.getElementById("quickAccessBtn")) {
        //             document.getElementById("quickAccessBtn").classList.remove("btn-hover-shinebottom");
        //         }
        //         if (document.getElementById("Chat")) {
        //             document.getElementById("Chat").classList.remove("chaticonpositionbottom");
        //         }
        //         if (document.getElementById("moderator1")) {
        //             document.getElementById("moderator1").classList.remove("bottomtotopchat1");
        //         }
        //         if (document.getElementById("message-form")) {
        //             document.getElementById("message-form").classList.remove("bottomtotopchat1");
        //         }
        //     }
        // });
    }


    getUserDetails() {
        let self = this;
        const db = dbFirebaseApp.firestore();
        const userCollection = db.collection('MedexLive');
        // let ExistingUserQuery = new Promise((resolve, reject) => {
        let profilePicArray = [];
        userCollection.where('expo', '==', expoName)
            .onSnapshot(function (querySnapshot) {
                querySnapshot.docChanges().forEach(function (change) {
                    if (change.type === "added" && change.type !== "modified") {
                        console.log("New city: ", change.doc.data());
                        if (change.doc.data().platformLive === true) {
                            self.setState({ isBtnLive: true })
                        }
                        else if (change.doc.data().platformLive === false) {
                            self.setState({ isBtnLive: false })
                        }

                    }
                    if (change.type === "modified") {
                        console.log("Modified city: ", change.doc.data());
                        // if (change.type === "added" && change.type !== "modified") {
                        console.log("New city: ", change.doc.data());
                        if (change.doc.data().platformLive === true) {
                            self.setState({ isBtnLive: true })
                        }
                        else if (change.doc.data().platformLive === false) {
                            self.setState({ isBtnLive: false })
                        }

                        // }
                    }

                    // console.log(doc.id, " => ", doc.data());

                });

                // resolve(profilePicArray);

            });

    }

    isMobileDevice = () => {
        if (navigator.userAgent.match(/Android/i) ||
            navigator.userAgent.match(/webOS/i) ||
            navigator.userAgent.match(/iPhone/i) ||
            navigator.userAgent.match(/iPad/i) ||
            navigator.userAgent.match(/iPod/i) ||
            navigator.userAgent.match(/BlackBerry/i) ||
            navigator.userAgent.match(/Windows Phone/i)) {
            return true;
        } else {
            return false;
        }
    }

    goToLobby = () => {
        let str = window.location.href;
        // console.warn('string is ::', str.substring(str.lastIndexOf('/')+1))
        if (str.substring(str.lastIndexOf('/') + 1) !== 'entrance') {
            window.location.href = '/entrance'
        }
    }

    goToWebinar = () => {
        let str = window.location.href;
        if (str.substring(str.lastIndexOf('/') + 1) !== 'webinar-hall') {
            window.location.href = '/webinar-hall-2d'
        }
    }

    goToBreakout = () => {
        let str = window.location.href;
        if (str.substring(str.lastIndexOf('/') + 1) !== 'breakout-page') {
            window.location.href = '/breakout-page'
        }
    }

    goToArchiveGallary = () => {
        let str = window.location.href;
        if (str.substring(str.lastIndexOf('/') + 1) !== 'archive') {
            window.location.href = '/archive'
        }
    }

    // goToCountryRooms = () => {
    //     let str = window.location.href;
    //     if (str.substring(str.lastIndexOf('/') + 1) !== 'country') {
    //         window.location.href = '/country'
    //     }
    // }

    goToBreakTimeZone = () => {
        let str = window.location.href;
        if (str.substring(str.lastIndexOf('/') + 1) !== 'entertainment-zone') {
            window.location.href = '/entertainment-zone'
        }
    }

    goToDisplayGallarySection = () => {
        let str = window.location.href;
        if (str.substring(str.lastIndexOf('/') + 1) !== 'display') {
            window.location.href = '/display'
        }
    }

    goToMedexFaculty = () => {
        let str = window.location.href;
        if (str.substring(str.lastIndexOf('/') + 1) !== 'medex-faculty') {
            window.location.href = '/faculty-room'
        }
    }

    goToAgenda = () => {
        document.getElementById('location1').style.display = 'block'
    }

    goToInfo = () => {
        document.getElementById('info1').style.display = 'block'
    }

    goToFeedback = () => {
        console.log("Feedback link");

        // this.setState({ shouldShowNotification: true, notificationMsg: "Feedback Link for Event" });
        // setTimeout(() => {
        //     this.setState({ shouldShowNotification: false });
        // }, 6000);

        let myUid = localStorage.getItem('uid') ? localStorage.getItem('uid') : "ZUEFqTqgEuDGrkz";
        window.open(`https://event.merzanatomyworkshop.com/feedback.html#${myUid}`, "_blank");

        // window.open('https://boehringeringelheim.eu.qualtrics.com/jfe/form/SV_6EagGCEAT29mqpf?event_name=META_ILD_VIRTUAL_MASTERCLASS_2020&country_code=MC', '_blank')
        // window.open('https://boehringeringelheim.eu.qualtrics.com/jfe/form/SV_6EagGCEAT29mqpf?event_name=MEDEX_2021_&country_code=MC', '_blank')
    }

    userLogout = () => {


        console.warn('update last scene end time')
        const db = analyticsFirebase.firestore();
        db.collection("MEDEXLiveUsers").doc(localStorage.getItem('analyticsDocRef')).update({
            endTime: new Date().getTime(),
        })
            .then(function (docRef) {
                console.log("Document written with ID: ", localStorage.getItem('analyticsDocRef'));
                // currentDoc = docRef;

                localStorage.clear()
                window.location.href = "/"
            })
            .catch(function (error) {
                console.error("Error adding document: ", error);
            });






        // authFirebaseApp.auth().signOut().then(res => {
        //     console.log('log out')
        // })
        // this.props.goToPage(PAGETYPE.ENTERTAINMENT);
    }
    nurseAgenda = () => {
        document.getElementById('nurseAgenda').style.display = 'block'
        document.getElementById('agendaNurseBtn').setAttribute('class', 'btnBlueGreen active');
        document.getElementById('agendaNeurologistBtn').setAttribute('class', 'btnBlueGreen margin');
        document.getElementById('neurologistAgenda').style.display = 'none'
    }

    neurologistAgenda = () => {
        document.getElementById('neurologistAgenda').style.display = 'block'
        document.getElementById('agendaNeurologistBtn').setAttribute('class', 'btnBlueGreen margin active');
        document.getElementById('agendaNurseBtn').setAttribute('class', 'btnBlueGreen');
        document.getElementById('nurseAgenda').style.display = 'none'
    }

    closePopup = () => {
        document.getElementById('location1').style.display = 'none'
    }

    changeTab = (tabNum) => {
        if (document.getElementById('tab-1').classList.contains('tab-current')) {
            document.getElementById('tab-1').classList.remove('tab-current');
            document.getElementById('tabHeader1').classList.remove('tab-active');
        }

        if (document.getElementById('tab-2').classList.contains('tab-current')) {
            document.getElementById('tab-2').classList.remove('tab-current');
            document.getElementById('tabHeader2').classList.remove('tab-active');
        }
        document.getElementById(`tab-${tabNum}`).classList.add('tab-current');
        document.getElementById(`tabHeader${tabNum}`).classList.add('tab-active');
    }

    infoButtonclose = () => {
        document.getElementById('info1').style.display = 'none'
    }

    changeAgendaDate = (activeTabNum) => {
        console.warn('Should open tab', activeTabNum);
        for (let i = 1; i <= 11; i++) {
            document.getElementById('tab-' + i).style.display = 'none';

            if (document.getElementById('tab-' + i).classList.contains('tab-current')) {
                document.getElementById('tab-' + i).classList.remove('tab-current');
            }

            if (document.getElementById('btn-' + i).classList.contains('tab-active')) {
                document.getElementById('btn-' + i).classList.remove('tab-active');
            }
        }
        document.getElementById('tab-' + activeTabNum).style.display = 'block';
        document.getElementById('tab-' + activeTabNum).classList.add('tab-current');
        document.getElementById('btn-' + activeTabNum).classList.add('tab-active');
    }

    startVideo = () => {
        this.setState({ isVideoStart: true })
    }

    closeVideo = () => {
        this.setState({ isVideoStart: false })
    }


    playVideo1 = () => {
        if (document.getElementById('2dVideo1') &&
            document.getElementById('Pause2dVideo1') &&
            document.getElementById('Play2dVideo1')) {
            document.getElementById('2dVideo1').play();
            document.getElementById('2dVideo1').volume = 1;
            document.getElementById('Pause2dVideo1').style.display = 'block';
            document.getElementById('Play2dVideo1').style.display = 'none';
            localStorage.setItem('isVideoWatched', 'true')
            // document.getElementById('countdown1').style.display = 'block';

        }
    }

    pauseVideo1 = () => {
        if (document.getElementById('2dVideo1') &&
            document.getElementById('Pause2dVideo1') &&
            document.getElementById('Play2dVideo1')) {
            document.getElementById('2dVideo1').pause();

            document.getElementById('2dVideo1').volume = 0;
            document.getElementById('Play2dVideo1').style.display = 'block'
            document.getElementById('Pause2dVideo1').style.display = 'none'
            // document.getElementById('countdown1').style.display = 'none';
        }
    }
    openbottommenu = () => {
        document.getElementById("bottommenu").classList.remove("bottomaniamtion");
        document.getElementById("Mobmenu").style.display = "none";
        document.getElementById("Mobmenuclose").style.display = "flex";
        if ((document.getElementById("myScrollingChat"))) {

            document.getElementById("myScrollingChat").classList.remove("ishiddenchat");
        }
        if ((document.getElementById("Chat"))) {

            document.getElementById("Chat").classList.add("chaticonposition2");
        }
        if (document.getElementById("quickAccessBtn")) {
            document.getElementById("quickAccessBtn").classList.remove("btn-hover-shinebottom");
        }

    }
    closebottommenu = () => {
        document.getElementById("bottommenu").classList.add("bottomaniamtion");
        document.getElementById("Mobmenu").style.display = "flex";
        document.getElementById("Mobmenuclose").style.display = "none";
        if ((document.getElementById("Chat"))) {

            document.getElementById("Chat").classList.remove("chaticonposition2");
        }
        if (document.getElementById("quickAccessBtn")) {
            document.getElementById("quickAccessBtn").classList.add("btn-hover-shinebottom");
        }
        // if (document.getElementById("BOTTTOMchatbox"))
        //     document.getElementById("BOTTTOMchatbox").classList.add("bottomchatbox1");
        // if (document.getElementById("message-form"))
        //     document.getElementById("message-form").classList.add("chat-textnormalani");

    }



    render() {
        return (
            <div>
                {this.state.isVideoStart &&
                    <div>
                        <div className="overlayVideo" id="VideoOverlay1" >
                            {/* <div id="countdown1" style={{ display: 'none', position: 'fixed', top: '30px', width: '70px', textAlign: 'center', left: '50%', transform: 'translate(-50%, -50%)', color: 'white', padding: '3px 10px', border: '2px solid white', borderRadius: '5px' }}> <span></span> </div> */}

                        </div>


                        <div id="video-popup1">
                            <button id="closeBtn" className="closebtnposition" onClick={this.closeVideo} style={{ outline: 'none' }}>
                                <img src={closeBtn} alt="play" className="closebtnwidth"></img>
                            </button>
                            <p className="videoTitle">Guided Tour by Emma</p>
                            <video id="2dVideo1" className="videopopup" playsInline crossOrigin="anonymous" src={entranceVideo} poster={videoPosterImg} preload="auto" ></video>
                            <button id="Play2dVideo1" onClick={this.playVideo1} style={{ outline: 'none',border:'0',background:'transparent' }}>
                                <img src={playImg} alt="play" className="playbtnwidth"></img>
                                <p className="playvideotext">Play Guided Tour</p>
                            </button>
                            <button id="Pause2dVideo1" style={{ display: 'none', outline: 'none',border:'0',background:'transparent' }} onClick={this.pauseVideo1} >
                                <img src={pauseImg} alt="play" className="playbtnwidth"></img>
                                <p className="playvideotext">Pause Guided Tour</p>

                            </button>
                            {/* <button id="startExperienceButton1" style={{ display: 'none' }} className="startExperianceBtn heightExperiance" onClick={this.startExperiance} >Enter Event</button> */}


                        </div>
                    </div>}
                {this.state.isBtnLive && localStorage.getItem('Location') !== 'archive-gallery' &&
                    <button id="quickAccessBtn" onClick={this.goToArchiveGallary} className="btn-hover-shine btn-glow btn-hover-shinebottom" >Quick Access to Archive Session</button>
                 } 

                {/* AGENDA POPUP */}
                <div className="modal" id="location1" style={{ display: 'none' }}>
                    <div className="modal-dialog modal-dialog-centered modal-xl">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title green-text" id="staticBackdropLabel">Agenda</h5>

                                <button type="button" className="close white-color" data-dismiss="modal" onClick={this.closePopup}>x</button>
                            </div>
                            {/* <!-- Agenda section --> */}
                            <section id="agenda">
                                <div className="container">
                                    <div className="schedule-tab">
                                        <a id="tabHeader1" className="schedule-tab__item tab-active leftborder" data-tab="tab-1" href="#tab-1" onClick={() => this.changeTab(1)}>
                                            <h2>Day <span>01</span></h2>
                                            <p>April 9, 2021</p>
                                        </a>
                                        <a id="tabHeader2" className="schedule-tab__item  rigthradius" data-tab="tab-2" href="#tab-2" onClick={() => this.changeTab(2)}>
                                            <h2>Day <span>02</span> </h2>
                                            <p>April 10, 2021</p>
                                        </a>

                                    </div>

                                    <div id="tab-1" className="schedule-table tab-current">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="schedule-listing">
                                                    <div className="row schedule-item" style={{ borderBottom: 0 }}>
                                                        <div className="col-12 col-md-12 col-lg-12">
                                                            <h4 className="remfont">
                                                                Session 1 :
                                                                Forehead fillers
                                                             </h4>
                                                        </div>
                                                    </div>
                                                    <div className="schedule-item" style={{ borderBottom: 0 }}>
                                                        <div className="sc-time">16:00-17:10 </div>

                                                        <div className="sc-pic">
                                                            <img src={sabestianImg} className="img-circle" alt="" />
                                                        </div>
                                                        <div className="sc-name">
                                                            <h4>Prof. Sebastian Cotofana </h4>
                                                        </div>
                                                        <div className="sc-info">
                                                            <p>Anatomy of the forehead </p>
                                                        </div>
                                                    </div>
                                                    <div className="schedule-item" style={{ borderBottom: 0 }}>
                                                        <div className="sc-time paddingzero"></div>

                                                        <div className="sc-pic">
                                                            <img src={mattImg} className="img-circle" alt="" />
                                                        </div>
                                                        <div className="sc-name">
                                                            <h4>Dr. Matt Stefanelli</h4>
                                                        </div>
                                                        <div className="sc-info">
                                                            <p>Live filler injection technique </p>
                                                        </div>
                                                        <div className="clearfix"></div>
                                                    </div>
                                                    <div className="schedule-item">
                                                        <div className="sc-time paddingzero"></div>

                                                        <div className="sc-pic">
                                                            <img src={ramiImg} className="img-circle" alt="" />
                                                        </div>
                                                        <div className="sc-name">
                                                            <h4>Dr. Rami Haidar </h4>
                                                        </div>
                                                        <div className="sc-info">
                                                            <p>Tackling the potential complications of HA fillers </p>
                                                        </div>
                                                        <div className="clearfix"></div>
                                                    </div>
                                                </div>
                                                <div className="schedule-listing">
                                                    <div className="row schedule-item" style={{ borderBottom: 0 }}>
                                                        <div className="col-12 col-md-12 col-lg-12">
                                                            <h4 className="remfont">
                                                                Session 2 :
                                                                            Temple fillers </h4>
                                                        </div>
                                                    </div>

                                                    <div className="schedule-item" style={{ borderBottom: 0 }}>
                                                        <div className="sc-time">17:20-18:30</div>
                                                        <div className="sc-pic">
                                                            <img src={sabestianImg} className="img-circle" alt="" />
                                                        </div>
                                                        <div className="sc-name">
                                                            <h4>Prof. Sebastian Cotofana </h4>
                                                        </div>
                                                        <div className="sc-info">
                                                            <p>Anatomy of the Temples</p>
                                                        </div>
                                                        <div className="clearfix"></div>
                                                    </div>
                                                    <div className="schedule-item" style={{ borderBottom: 0 }}>
                                                        <div className="sc-time paddingzero"></div>
                                                        <div className="sc-pic">
                                                            <img src={mattImg} className="img-circle" alt="" />
                                                        </div>
                                                        <div className="sc-name">
                                                            <h4>Dr. Matt Stefanelli</h4>
                                                        </div>
                                                        <div className="sc-info">
                                                            <p>Live filler injection technique </p>
                                                        </div>
                                                        <div className="clearfix"></div>
                                                    </div>
                                                    <div className="schedule-item">
                                                        <div className="sc-time paddingzero"></div>
                                                        <div className="sc-pic">
                                                            <img src={nabilImg} className="img-circle" alt="" />
                                                        </div>
                                                        <div className="sc-name">
                                                            <h4>Dr. Nabil Fakih </h4>
                                                        </div>
                                                        <div className="sc-info">
                                                            <p>Deep versus superficial temples filler injections - A
                                                                                    debate </p>
                                                        </div>
                                                        <div className="clearfix"></div>
                                                    </div>
                                                </div>
                                                <div className="schedule-listing">
                                                    <div className="schedule-item">
                                                        <div className="sc-time">18:30-18:40</div>
                                                        <div className="sc-pic">
                                                        </div>
                                                        <div className="sc-name">
                                                        </div>
                                                        <div className="sc-info">
                                                            <h3 >Q&A</h3>
                                                        </div>
                                                        <div className="clearfix"></div>
                                                    </div>
                                                </div>

                                                <div className="schedule-listing">
                                                    <div className="schedule-item">
                                                        <div className="sc-time">18:40- 19:10</div>
                                                        <div className="sc-pic">
                                                        </div>
                                                        <div className="sc-name">
                                                        </div>
                                                        <div className="sc-info">
                                                            <h3 >Break </h3>
                                                        </div>
                                                        <div className="clearfix"></div>
                                                    </div>
                                                </div>
                                                <div className="schedule-listing">
                                                    <div className="row schedule-item" style={{ borderBottom: 0 }}>
                                                        <div className="col-12 col-md-12 col-lg-12">
                                                            <h4 className="remfont">
                                                                Session 3 :
                                                                                        Undereye and Midface </h4>
                                                        </div>
                                                    </div>
                                                    <div className="schedule-item" style={{ borderBottom: 0 }}>
                                                        <div className="sc-time">19:10-20:20 </div>
                                                        <div className="sc-pic">
                                                            <img src={sabestianImg} className="img-circle" alt="" />
                                                        </div>
                                                        <div className="sc-name">
                                                            <h4>Prof. Sebastian Cotofana </h4>
                                                        </div>
                                                        <div className="sc-info">
                                                            <p>Anatomy of the under-eye and upper cheeks </p>
                                                        </div>
                                                        <div className="clearfix"></div>
                                                    </div>
                                                    <div className="schedule-item" style={{ borderBottom: 0 }}>
                                                        <div className="sc-time paddingzero"></div>
                                                        <div className="sc-pic">
                                                            <img src={mattImg} className="img-circle" alt="" />
                                                        </div>
                                                        <div className="sc-name">
                                                            <h4>Dr. Matt Stefanelli</h4>
                                                        </div>
                                                        <div className="sc-info">
                                                            <p>Live filler injection technique </p>
                                                        </div>
                                                        <div className="clearfix"></div>
                                                    </div>
                                                    <div className="schedule-item">
                                                        <div className="sc-time paddingzero"></div>
                                                        <div className="sc-pic">
                                                            <img src={mohamedImg} className="img-circle" alt="" />
                                                        </div>
                                                        <div className="sc-name">
                                                            <h4>Dr. Mohammed G. Turkmani</h4>
                                                        </div>
                                                        <div className="sc-info">
                                                            <p>Using filler to fix different tear trough deformities
                                                                                                </p>
                                                        </div>
                                                        <div className="clearfix"></div>
                                                    </div>
                                                </div>
                                                <div className="schedule-listing">
                                                    <div className="row schedule-item" style={{ borderBottom: 0 }}>
                                                        <div className="col-12 col-md-12 col-lg-12">
                                                            <h4 className="remfont">
                                                                Session 4 : Lip Fillers </h4>
                                                        </div>
                                                    </div>
                                                    <div className="schedule-item" style={{ borderBottom: 0 }}>
                                                        <div className="sc-time">20:20-21:30 </div>
                                                        <div className="sc-pic">
                                                            <img src={sabestianImg} className="img-circle" alt="" />
                                                        </div>
                                                        <div className="sc-name">
                                                            <h4>Prof. Sebastian Cotofana </h4>
                                                        </div>
                                                        <div className="sc-info">
                                                            <p>Anatomy of the lips </p>
                                                        </div>
                                                        <div className="clearfix"></div>
                                                    </div>
                                                    <div className="schedule-item" style={{ borderBottom: 0 }}>
                                                        <div className="sc-time paddingzero"></div>

                                                        <div className="sc-pic">
                                                            <img src={mattImg} className="img-circle" alt="" />
                                                        </div>
                                                        <div className="sc-name">
                                                            <h4>Dr. Matt Stefanelli</h4>
                                                        </div>
                                                        <div className="sc-info">
                                                            <p>Live filler injection technique </p>
                                                        </div>
                                                        <div className="clearfix"></div>
                                                    </div>
                                                    <div className="schedule-item">
                                                        <div className="sc-time paddingzero"></div>
                                                        <div className="sc-pic">
                                                            <img src={naifImg} className="img-circle" alt="" />
                                                        </div>
                                                        <div className="sc-name">
                                                            <h4> Dr. Naif Al Nomair</h4>
                                                        </div>
                                                        <div className="sc-info">
                                                            <p>Tips for lips
                                                                                                            </p>
                                                        </div>
                                                        <div className="clearfix"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                    <div id="tab-2" className="schedule-table">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div className="schedule-listing">
                                                    <div className="row schedule-item" style={{ borderBottom: 0 }}>
                                                        <div className="col-12 col-md-12 col-lg-12 marginbottomzero">
                                                            <h4 className="remfont"> Session 1 :
                                                            Individualized approach to
                                                            relax facial
                                                            mimic
                                                            hyperactivity & keep natural appearance with one and
                                                                                                            only pure BoNTA</h4>
                                                        </div>
                                                    </div>
                                                    <div className="schedule-item" style={{ borderBottom: 0 }}>
                                                        <div className="sc-time">16:00-17:10</div>
                                                        <div className="sc-pic">
                                                            <img src={sabestianImg} className="img-circle" alt="" />
                                                        </div>
                                                        <div className="sc-name">
                                                            <h4>Prof. Sebastian Cotofana </h4>
                                                        </div>
                                                        <div className="sc-info">
                                                            <p>Anatomy of the facial muscles</p>
                                                        </div>
                                                        <div className="clearfix"></div>
                                                    </div>
                                                    <div className="schedule-item">
                                                        <div className="sc-time paddingzero"></div>
                                                        <div className="sc-pic">
                                                            <img src={tatjanaImg} className="img-circle" alt="" />
                                                        </div>
                                                        <div className="sc-name">
                                                            <h4>Dr. Tatjana Pavicic</h4>
                                                        </div>
                                                        <div className="sc-info">
                                                            <p>Toxin injection technique
                                                                                                                    <br />Details as per indication followed by longevity and safety aspects

                                                                                                                    </p>
                                                        </div>
                                                        <div className="clearfix"></div>
                                                    </div>
                                                </div>
                                                <div className="schedule-listing">
                                                    <div className="row schedule-item" style={{ borderBottom: 0 }}>
                                                        <div className="col-12 col-md-12 col-lg-12 marginbottomzero">
                                                            <h4 className="remfont"> Session 2 : Jawline and
                                                                                                                            Chin</h4>
                                                        </div>
                                                    </div>
                                                    <div className="schedule-item" style={{ borderBottom: 0 }}>
                                                        <div className="sc-time">17:10-18:20 </div>
                                                        <div className="sc-pic">
                                                            <img src={sabestianImg} className="img-circle" alt="" />
                                                        </div>
                                                        <div className="sc-name">
                                                            <h4>Prof. Sebastian Cotofana </h4>
                                                        </div>
                                                        <div className="sc-info">
                                                            <p>Anatomy of the Jaw and Chin</p>
                                                        </div>
                                                        <div className="clearfix"></div>
                                                    </div>
                                                    <div className="schedule-item" style={{ borderBottom: 0 }}>
                                                        <div className="sc-time paddingzero"></div>
                                                        <div className="sc-pic">
                                                            <img src={mattImg} className="img-circle" alt="" />
                                                        </div>
                                                        <div className="sc-name">
                                                            <h4>Dr. Matt Stefanelli </h4>
                                                        </div>
                                                        <div className="sc-info">
                                                            <p>Live filler injection technique</p>

                                                        </div>
                                                        <div className="clearfix"></div>
                                                    </div>
                                                    <div className="schedule-item">
                                                        <div className="sc-time paddingzero"></div>

                                                        <div className="sc-pic">
                                                            <img src={ramiImg} className="img-circle" alt="" />
                                                        </div>
                                                        <div className="sc-name">
                                                            <h4>Dr. Rami Haidar </h4>
                                                        </div>
                                                        <div className="sc-info">
                                                            <p>Using CaHA in the Jawline and Chin </p>

                                                        </div>
                                                        <div className="clearfix"></div>
                                                    </div>
                                                </div>


                                                <div className="schedule-listing">
                                                    <div className="schedule-item">
                                                        <div className="sc-time">18:20-18:40</div>
                                                        <div className="sc-pic">
                                                        </div>
                                                        <div className="sc-name">

                                                        </div>
                                                        <div className="sc-info">
                                                            <h3>Q&amp;A</h3>

                                                        </div>
                                                        <div className="clearfix"></div>
                                                    </div>


                                                </div>

                                                <div className="schedule-listing">
                                                    <div className="schedule-item">
                                                        <div className="sc-time">18:40-19:10 </div>
                                                        <div className="sc-pic">
                                                        </div>
                                                        <div className="sc-name">

                                                        </div>
                                                        <div className="sc-info">
                                                            <h3>Break</h3>

                                                        </div>
                                                        <div className="clearfix"></div>
                                                    </div>
                                                </div>


                                                <div class="schedule-listing">
                                                    <div class="row schedule-item" style={{ borderBottom: 0 }}>
                                                        <div class="col-12 col-md-12 col-lg-12 marginbottomzero">
                                                            <h4 class="remfont"> Session 3 : Hybrid Filler
                                                            for Facial
                                                            Prolifiting
                                                        </h4>
                                                        </div>
                                                    </div>
                                                    <div class="schedule-item" style={{ borderBottom: 0 }}>
                                                        <div class="sc-time">19:10-20:20 </div>

                                                        <div class="combined-container">
                                                            <div class="sc-pic">
                                                                <img src={sabestianImg} class="img-circle"
                                                                    alt="" />
                                                            </div>
                                                            <div class="sc-name">
                                                                <h4>Prof. Sebastian Cotofana </h4>
                                                            </div>

                                                            <div class="sc-pic">
                                                                <img src={nabilImg} class="img-circle"
                                                                    alt="" />
                                                            </div>
                                                            <div class="sc-name">
                                                                <h4>Dr. Nabil Fakih </h4>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="schedule-item">
                                                        <div class="sc-time paddingzero"></div>

                                                        <div class="sc-pic">
                                                        </div>
                                                        <div class="sc-name">
                                                        </div>
                                                        <div class="sc-info">
                                                            <p style={{ display: 'none' }}>Newest data on CaHA and HA Rheology </p>
                                                            <p>Combining CaHA and HA: a practical experience </p>

                                                        </div>
                                                        <div class="clearfix"></div>
                                                    </div>

                                                </div>

                                                <div className="schedule-listing">
                                                    <div className="row schedule-item" style={{ borderBottom: 0 }}>
                                                        <div className="col-12 col-md-12 col-lg-12 marginbottomzero">
                                                            <h4 className="remfont"> Session 4 : Nose filler
                                                            </h4>
                                                        </div>
                                                    </div>
                                                    <div className="schedule-item" style={{ borderBottom: 0 }}>
                                                        <div className="sc-time">20:20-21:30 </div>

                                                        <div className="sc-pic">
                                                            <img src={sabestianImg} className="img-circle" alt="" />
                                                        </div>
                                                        <div className="sc-name">
                                                            <h4>Prof. Sebastian Cotofana </h4>
                                                        </div>
                                                        <div className="sc-info">
                                                            <p>Anatomy of the nose </p>
                                                        </div>
                                                        <div className="clearfix"></div>
                                                    </div>
                                                    <div className="schedule-item" style={{ borderBottom: 0 }}>
                                                        <div className="sc-time paddingzero"></div>

                                                        <div className="sc-pic">
                                                            <img src={mattImg} className="img-circle" alt="" />
                                                        </div>
                                                        <div className="sc-name">
                                                            <h4>Dr. Matt Stefanelli </h4>
                                                        </div>
                                                        <div className="sc-info">
                                                            <p>Live injection of fillers to enhance nose bridge </p>

                                                        </div>
                                                        <div className="clearfix"></div>
                                                    </div>
                                                    <div className="schedule-item" style={{ borderBottom: 0 }}>
                                                        <div className="sc-time paddingzero"></div>

                                                        <div className="sc-pic">
                                                            <img src={nabilImg} className="img-circle" alt="" />
                                                        </div>
                                                        <div className="sc-name">
                                                            <h4>Dr. Nabil Fakih </h4>
                                                        </div>
                                                        <div className="sc-info">
                                                            <p>Up-to-date scientific data on the different ways of using
                                                            fillers in nose </p>

                                                        </div>
                                                        <div className="clearfix"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                    </div>

                                </div>


                            </section>
                        </div>
                    </div>
                </div>
                {/* AGENDA POPUP */}



                {/* INFO POPUP */}
                <div className="modal" id="info1" >
                    <div className="modal-dialog modal-dialog-centered" >
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title green-text" id="staticBackdropLabel">Info</h5>

                                <button type="button" className="close black-color" data-dismiss="modal" onClick={() => this.infoButtonclose()}>&times;</button>
                            </div>
                            <div className="modal-body">

                                {
                                    (this.isMobileDevice()) ?
                                        <img src={tutorialimg2} style={{ width: '100%' }} />
                                        :
                                        <img src={tutorialimg1} style={{ width: '100%' }} />
                                }


                            </div>
                        </div>
                    </div>
                </div>
                {/* INFO POPUP */}
                <div className="mobmenu" id="Mobmenu">
                    <img src={menuImg} className="widthmenuicon" alt="" onClick={this.openbottommenu} />
                </div>
                <div className="mobmenuclose" id="Mobmenuclose">
                    <img src={closeImg} className="widthmenuicon" alt="" onClick={this.closebottommenu} />
                </div>
                <div id="bottommenu" className="bottomaniamtion">
                    <ul className="list-unstyled  flexicon scrolltypewhite">
                        <li className="flexcolumn" onClick={this.goToLobby}>
                            <img src={lobbyImg} className="widthicon" alt="Webinar" />
                            <span className="cenetrtext bottomtext">Lobby</span>
                        </li>

                        <li className="flexcolumn" onClick={this.goToWebinar}>
                            <img src={webinarImg} className="widthicon" alt="Webinar" />
                            <span className="cenetrtext bottomtext">Webinar Hall</span>
                        </li>
                        {/* <li className="flexcolumn" onClick={this.goToBreakout} >
                            <img src={breakoutimg} className="widthicon" alt="Breakout" />
                            <span className="cenetrtext bottomtext">breakout Room</span>

                        </li> */}
                        {/* <li className="flexcolumn" onClick={this.goToBreakout2} >
                            <img src={breakoutimg} className="widthicon" alt="Breakout" />
                            <span className="cenetrtext bottomtext">breakout Room 2</span>

                        </li> */}
                        {/* <li className="flexcolumn" onClick={() => this.chatRoomButton(PAGETYPE.CHATROOM)}>
                                <img src={chatroomImg} className="widthicon" alt="Chat" />
                                <span className="cenetrtext bottomtext">Chat Room</span>
                            </li> */}
                        <li className="flexcolumn" onClick={this.goToMedexFaculty}>
                            <img src={facultyIcon} className="widthicon" alt="Gallary" />
                            <span className="cenetrtext bottomtext">Faculty Room</span>
                        </li>
                        {/* <li className="flexcolumn" onClick={this.goToCountryRooms}>
                            <img src={displaygallaryImg} className="widthicon" alt="Gallary" />
                            <span className="cenetrtext bottomtext">Country Experience</span>
                        </li> */}
                        <li className="flexcolumn" onClick={this.goToDisplayGallarySection}>
                            <img src={displayGallery} className="widthicon" alt="Gallary" />
                            <span className="cenetrtext bottomtext">Display Gallery</span>
                        </li>

                        <li id="expohall" className="flexcolumn" onClick={this.goToArchiveGallary}>
                            <img src={ArchiveImg} className="widthicon" alt="Gallary" />
                            <span className="cenetrtext bottomtext">Archive Gallery</span>
                        </li>
                        <li className="flexcolumn" onClick={this.goToBreakTimeZone}>
                            <img src={entertainmentImg} className="widthicon" data-toggle="modal" alt="Entertainment"
                                data-target="#filterpopup" />
                            <span className="cenetrtext bottomtext">Break Time Zone</span>

                        </li>
                        <li className="flexcolumn" onClick={this.goToAgenda} >
                            <img src={agendaImg} className="widthicon" data-target="#location1" data-toggle="modal" alt="Location" />
                            <span className="cenetrtext bottomtext">Agenda</span>

                        </li>
                        {/* <li className="flexcolumn" onClick={this.goToInfo}>
                            <img src={infoimg} className="widthicon" data-target="#info1" data-toggle="modal" alt="Location" />
                            <span className="cenetrtext bottomtext">Info</span>

                        </li> */}

                        <li className="flexcolumn" onClick={this.goToFeedback} >
                            <img src={feedbackImg} className="widthicon" alt="Feedback" />
                            <span className="cenetrtext bottomtext">Feedback</span>

                        </li>
                        <li className="flexcolumn"  >
                            <img src={emma} className="widthicon" alt="Log out" onClick={this.startVideo} />
                            <span className="cenetrtext bottomtext">Guided Tour</span>
                        </li>
                        <li className="flexcolumn"  >
                            <img src={logout} className="widthicon" alt="Log out" onClick={this.userLogout} />
                            <span className="cenetrtext bottomtext">Log Out</span>

                        </li>



                        {/* <li className="flexcolumn" onClick={() => this.locationButton()}>
                                <img src={locationImg} className="widthicon" data-target="#location1" data-toggle="modal" alt="Location" />
                                <span className="cenetrtext bottomtext">Location</span>

                            </li> */}
                    </ul>
                </div>

                {this.state.shouldShowNotification && <CustomNotification msg={this.state.notificationMsg} />}

            </div>
        )
    }
}
